// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --borderRadius: 2px;
}

.app-components-ContextMenu-___ContextMenu-module__container {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  border: solid 1px #bcbcbc;
  border-radius: 4px;
  box-shadow: 1px 1px 10px -2px rgba(0, 0, 0, 0.5);
  min-width: 250px;
  position: absolute;
  z-index: 6000;
}

.app-components-ContextMenu-___ContextMenu-module__box {
  background-color: #fff;
  border: solid 1px #bcbcbc;
  box-shadow: 1px 1px 10px -2px rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  min-width: 250px;
  z-index: 1001;
  position: absolute;
}

.app-components-ContextMenu-___ContextMenu-module__box.app-components-ContextMenu-___ContextMenu-module__subItems {
    visibility: hidden;
    left: 100%;
    position: absolute;
    top: 0px;
  }

.app-components-ContextMenu-___ContextMenu-module__item {
  padding: 5px 15px;
  position: relative;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}

.app-components-ContextMenu-___ContextMenu-module__item:focus-within {
    box-shadow: 0px 0px 0px 50px rgba(0, 0, 0, 0.08) inset !important;
  }

.app-components-ContextMenu-___ContextMenu-module__item:focus-within {
    cursor: pointer;
    box-shadow: 0px 0px 0px 50px rgba(0, 0, 0, 0.05) inset;
  }

.app-components-ContextMenu-___ContextMenu-module__item:focus-within > .app-components-ContextMenu-___ContextMenu-module__subItems {
      visibility: visible;
    }

.app-components-ContextMenu-___ContextMenu-module__item:first-child {
    border-top-left-radius: var(--borderRadius);
    border-top-right-radius: var(--borderRadius);
  }

.app-components-ContextMenu-___ContextMenu-module__item:last-child {
    border-bottom-left-radius: var(--borderRadius);
    border-bottom-right-radius: var(--borderRadius);
  }

.app-components-ContextMenu-___ContextMenu-module__item .app-components-ContextMenu-___ContextMenu-module__text {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

.app-components-ContextMenu-___ContextMenu-module__item .app-components-ContextMenu-___ContextMenu-module__text .app-components-ContextMenu-___ContextMenu-module__label {
      display: flex;
      flex-direction: row;
      align-items: center;
      align-content: center;
      width: inherit;
      white-space: nowrap;
    }

.app-components-ContextMenu-___ContextMenu-module__item .app-components-ContextMenu-___ContextMenu-module__text .app-components-ContextMenu-___ContextMenu-module__label .app-components-ContextMenu-___ContextMenu-module__leftLabel {
        width: 25px;
        color: grey;
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: center;
        margin-left: -7px;
        margin-right: 5px;
      }

.app-components-ContextMenu-___ContextMenu-module__item .app-components-ContextMenu-___ContextMenu-module__text .app-components-ContextMenu-___ContextMenu-module__rightLabel {
      display: flex;
      align-items: center;
      align-content: center;
      justify-content: center;
      white-space: nowrap;
      padding-left: 5px;
    }

.app-components-ContextMenu-___ContextMenu-module__itemBreak {
  border-bottom: solid 1px #ccc;
}

.app-components-ContextMenu-___ContextMenu-module__arrow {
  position: absolute;
  top: 0;
  right: 15px;
  bottom: 0;
  display: flex;
  align-items: center;
}

.app-components-ContextMenu-___ContextMenu-module__searchInput {
  border: 1px solid rgba(0, 0, 0, 0.1);
  outline: none;
  width: 100%;
  border-radius: 3px;
}
`, "",{"version":3,"sources":["webpack://./app/components/ContextMenu/ContextMenu.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gDAAgD;EAChD,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AAOpB;;AANE;IACE,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,QAAQ;EACV;;AAGF;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,eAAe;AAmDjB;;AAlDE;IACE,iEAAiE;EACnE;;AACA;IACE,eAAe;IACf,sDAAsD;EAIxD;;AAHE;MACE,mBAAmB;IACrB;;AAEF;IACE,2CAA2C;IAC3C,4CAA4C;EAC9C;;AACA;IACE,8CAA8C;IAC9C,+CAA+C;EACjD;;AACA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;EA4BhC;;AA3BE;MACE,aAAa;MACb,mBAAmB;MACnB,mBAAmB;MACnB,qBAAqB;MACrB,cAAc;MACd,mBAAmB;IAYrB;;AAVE;QACE,WAAW;QACX,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,qBAAqB;QACrB,uBAAuB;QACvB,iBAAiB;QACjB,iBAAiB;MACnB;;AAEF;MACE,aAAa;MACb,mBAAmB;MACnB,qBAAqB;MACrB,uBAAuB;MACvB,mBAAmB;MACnB,iBAAiB;IACnB;;AAIJ;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[":root {\n  --borderRadius: 2px;\n}\n\n.container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #fff;\n  border: solid 1px #bcbcbc;\n  border-radius: 4px;\n  box-shadow: 1px 1px 10px -2px rgba(0, 0, 0, 0.5);\n  min-width: 250px;\n  position: absolute;\n  z-index: 6000;\n}\n\n.box {\n  background-color: #fff;\n  border: solid 1px #bcbcbc;\n  box-shadow: 1px 1px 10px -2px rgba(0, 0, 0, 0.5);\n  border-radius: 4px;\n  min-width: 250px;\n  z-index: 1001;\n  position: absolute;\n  &.subItems {\n    visibility: hidden;\n    left: 100%;\n    position: absolute;\n    top: 0px;\n  }\n}\n\n.item {\n  padding: 5px 15px;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  &:focus-within {\n    box-shadow: 0px 0px 0px 50px rgba(0, 0, 0, 0.08) inset !important;\n  }\n  &:focus-within {\n    cursor: pointer;\n    box-shadow: 0px 0px 0px 50px rgba(0, 0, 0, 0.05) inset;\n    > .subItems {\n      visibility: visible;\n    }\n  }\n  &:first-child {\n    border-top-left-radius: var(--borderRadius);\n    border-top-right-radius: var(--borderRadius);\n  }\n  &:last-child {\n    border-bottom-left-radius: var(--borderRadius);\n    border-bottom-right-radius: var(--borderRadius);\n  }\n  .text {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    .label {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      align-content: center;\n      width: inherit;\n      white-space: nowrap;\n\n      .leftLabel {\n        width: 25px;\n        color: grey;\n        display: flex;\n        align-items: center;\n        align-content: center;\n        justify-content: center;\n        margin-left: -7px;\n        margin-right: 5px;\n      }\n    }\n    .rightLabel {\n      display: flex;\n      align-items: center;\n      align-content: center;\n      justify-content: center;\n      white-space: nowrap;\n      padding-left: 5px;\n    }\n  }\n}\n\n.itemBreak {\n  border-bottom: solid 1px #ccc;\n}\n\n.arrow {\n  position: absolute;\n  top: 0;\n  right: 15px;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n}\n\n.searchInput {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  outline: none;\n  width: 100%;\n  border-radius: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-components-ContextMenu-___ContextMenu-module__container`,
	"box": `app-components-ContextMenu-___ContextMenu-module__box`,
	"subItems": `app-components-ContextMenu-___ContextMenu-module__subItems`,
	"item": `app-components-ContextMenu-___ContextMenu-module__item`,
	"text": `app-components-ContextMenu-___ContextMenu-module__text`,
	"label": `app-components-ContextMenu-___ContextMenu-module__label`,
	"leftLabel": `app-components-ContextMenu-___ContextMenu-module__leftLabel`,
	"rightLabel": `app-components-ContextMenu-___ContextMenu-module__rightLabel`,
	"itemBreak": `app-components-ContextMenu-___ContextMenu-module__itemBreak`,
	"arrow": `app-components-ContextMenu-___ContextMenu-module__arrow`,
	"searchInput": `app-components-ContextMenu-___ContextMenu-module__searchInput`
};
export default ___CSS_LOADER_EXPORT___;
